import React, { useState } from 'react';
import { Upload, Loader2 } from 'lucide-react';
import api, { resolveImg } from '../../api';
import { toast } from 'sonner';

// Reusable image uploader. Shows preview and uploads to backend, stores a RELATIVE url (portable across domains)
const ImageUpload = ({ value, onChange, label = 'Image', testId = 'image-upload' }) => {
  const [uploading, setUploading] = useState(false);

  const displaySrc = resolveImg(value);

  const handleFile = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploading(true);
    try {
      const formData = new FormData();
      formData.append('file', file);
      const res = await api.post('/upload', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      // Store the RELATIVE url (e.g. /api/uploads/xxx) so it resolves on any domain (preview or production)
      onChange(res.data.url);
      toast.success('Image téléversée');
    } catch (err) {
      toast.error("Échec du téléversement de l'image");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div>
      <label className="block text-white/70 text-sm mb-2">{label}</label>
      <div className="flex items-center gap-4">
        {displaySrc && (
          <img src={displaySrc} alt="preview" className="w-24 h-24 object-cover rounded-lg border border-white/10" />
        )}
        <label className="cursor-pointer flex items-center gap-2 px-4 py-3 bg-white/5 border border-white/10 rounded-lg text-white/70 hover:border-fuchsia-500/50 transition-colors" data-testid={testId}>
          {uploading ? <Loader2 className="animate-spin" size={18} /> : <Upload size={18} />}
          {uploading ? 'Envoi...' : 'Choisir une image'}
          <input type="file" accept="image/*" onChange={handleFile} className="hidden" disabled={uploading} />
        </label>
      </div>
      <input
        type="text"
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        placeholder="ou collez une URL d'image"
        className="mt-2 w-full bg-white/5 border border-white/10 rounded-lg py-2 px-3 text-white text-sm focus:border-fuchsia-500/50 focus:outline-none"
      />
    </div>
  );
};

export default ImageUpload;
